import type { CachedChoiceLists } from "./cachedChoiceList";

export interface IdDescriptionBase {
  id: string;
  title: string;
  ViewId?: string;
  isProfessional?: boolean;
  // additional fields
  CurrentUserPermissions?: string;
  AllowProfessionalCodingForCurrentUser?: boolean;
  primary?: boolean | undefined | null;
  name?: string;
  service?: string;
  npi?: string;
  placeOfService?: string;
  approved?: boolean;
  isActive?: boolean;
}

export interface GroupingOptSelector {
  dataSource: IdDescriptionBase[];
  dataTextField: string;
  dataValueField: string;
}

export const RecordStatusCollection: IdDescriptionBase[] = [
  { id: "C", title: "Complete", ViewId: "C" },
  { id: "I", title: "Incomplete", ViewId: "I" },
];

export const CustomCollection: IdDescriptionBase[] = [];

export interface ChoiceListsState {
  facilities: IdDescriptionBase[];
  practices: IdDescriptionBase[];
  customFacilitiesAll: IdDescriptionBase[];
  customFacilities: IdDescriptionBase[];
  conversionFactorTypes: IdDescriptionBase[];
  encounterTypes: IdDescriptionBase[];
  patientStatuses: IdDescriptionBase[];
  services: IdDescriptionBase[];
  financialClasses: IdDescriptionBase[];
  recordStatuses: IdDescriptionBase[];
  sexes: IdDescriptionBase[];
  ofa: IdDescriptionBase[];
  providers: IdDescriptionBase[];
  payerFlags: IdDescriptionBase[];

  // current encounter can be with inactive facility - we need to load special facilities list for it
  currentEncounterFacility: string;
  currentEncounterFacilities: IdDescriptionBase[];

  // separated list
  newEncounterEncounterTypes: IdDescriptionBase[];

  // cached lists
  cachedLists: CachedChoiceLists;

  loading?: boolean;

  // loading indicators for specific lists
  loadingNewEncounterFacilities?: boolean;
  loadingDomainList?: boolean;
  loadingNewEncounterEncounterTypes?: boolean;
  loadingCustomFilterFacilities?: boolean;
  loadingConversionFactorTypes?: boolean;

  billingNotes: IdDescriptionBase[];
  serviceLocations: IdDescriptionBase[];
}

export interface PartialChoiceLists {
  facilities: IdDescriptionBase[];
  encounterTypes: IdDescriptionBase[];
}

export interface ChoiceListData {
  name: string;
  values: IdDescriptionBase[];
}
